module.exports = __webpack_public_path__ + "img/home-07-cosmopolitan-cerita-10.22b8a0f6.jpg";